import React from 'react';
import { SPECIAL_STATUSES } from '../../constants/status';

const COLOR_MAP = {
  'New Lead': 'bg-[#F1F3F4] text-[#5F6368]',
  'Documents Pending': 'bg-[#FEF7E0] text-[#E37400]',
  'Documents Completed': 'bg-[#E8F0FE] text-[#1A73E8]',
  'Assigned to Banker': 'bg-[#F3E8FD] text-[#8430CE]',
  'Under Review': 'bg-[#E8F0FE] text-[#185ABC]',
  'Query Raised': 'bg-[#FCE8E6] text-[#D93025]',
  Approved: 'bg-[#E6F4EA] text-[#1E8E3E]',
  Sanctioned: 'bg-[#E6F4EA] text-[#137333]',
  Disbursed: 'bg-[#E6F4EA] text-[#0D652D]',
  Closed: 'bg-[#F1F3F4] text-[#5F6368]',
  Rejected: 'bg-[#FCE8E6] text-[#D93025]',
  Cancelled: 'bg-[#FEF7E0] text-[#E37400]',
  Hold: 'bg-[#FEF7E0] text-[#F9AB00]',
};

const DISPLAY_LABELS = {
  'Documents Pending': 'Documents Pending',
  'Documents Completed': 'Documents Submitted',
  'Assigned to Banker': 'Assigned to Bank',
  'Under Review': 'Under Review',
  'Query Raised': 'Query Raised',
  Approved: 'Loan Approved',
  Sanctioned: 'Loan Sanctioned',
  Disbursed: 'Amount Disbursed',
  Closed: 'Completed',
  Rejected: 'Rejected',
  Cancelled: 'Cancelled',
  Hold: 'On Hold',
};

export default function StatusBadge({ status, size = 'sm' }) {
  const special = SPECIAL_STATUSES[status];
  const sizeClass = size === 'lg'
    ? 'text-sm px-3 py-1.5'
    : 'text-xs px-2.5 py-1';

  return (
    <span className={`inline-flex items-center gap-1.5 font-medium rounded-full ${sizeClass} ${
      COLOR_MAP[status] || 'bg-[#F1F3F4] text-[#5F6368]'
    }`}>
      <span className={`w-1.5 h-1.5 rounded-full bg-current ${special ? 'opacity-80' : 'opacity-60'}`} />
      {DISPLAY_LABELS[status] || status}
    </span>
  );
}
